import api from "./api";

/**
 * Download a file from an authenticated API endpoint.
 * Fetches via axios (so the JWT interceptor adds the Bearer token),
 * builds an object URL, and triggers a browser download.
 */
export async function downloadAuthed(path, filename) {
  const { data } = await api.get(path, { responseType: "blob" });
  const url = window.URL.createObjectURL(data);
  const a = document.createElement("a");
  a.href = url;
  if (filename) a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => window.URL.revokeObjectURL(url), 1000);
}
